var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbp-hashtag-cell"},[_vm._l((_vm.showItems),function(ref){
var name = ref.name;
var color = ref.color;
var _id = ref._id;
return _c('div',{key:_id,staticClass:"bbp-hashtag-cell-item",style:({
      color: ("rgba(" + color + ", 1)"),
      background: ("rgba(" + color + ", 0.15)")
    }),on:{"click":function($event){$event.stopPropagation();return _vm.onFilterTag(_id)}}},[_vm._v("\n    "+_vm._s(name)+"\n  ")])}),_vm._v(" "),(_vm.otherItems.length)?_c('div',{staticClass:"bbp-hashtag-cell__text",on:{"click":function($event){$event.stopPropagation();return _vm.onShowMore($event)}}},[_vm._v("\n    + "+_vm._s(_vm.otherItems.length)+" more\n  ")]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"bbp-bounce"}},[(_vm.isShowPopup)?_c('div',{staticClass:"bbp-hashtag-cell-popup",style:(_vm.popupPosition),on:{"mouseleave":function($event){_vm.isShowPopup = false}}},_vm._l((_vm.otherItems),function(ref){
    var name = ref.name;
    var color = ref.color;
    var _id = ref._id;
return _c('div',{key:_id,staticClass:"bbp-hashtag-cell-item",style:({
          color: ("rgba(" + color + ", 1)"),
          background: ("rgba(" + color + ", 0.15)")
        }),on:{"click":function($event){$event.stopPropagation();return _vm.onFilterTag(_id)}}},[_vm._v("\n        "+_vm._s(name)+"\n      ")])}),0):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-458df64f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/BBPTable/BBPStringCell/HashtagCell.vue
// module id = null
// module chunks = 